import React, { PropTypes } from 'react';
import { isEqual } from 'lodash';
import { LocaleService } from '@sm360/widget-commons-core-services';
import {
    FIELD_LENGTH,
    InputDropDown,
    InputText,
    ValidationService,
    GroupResponseService,
} from '@sm360/widget-commons-forms';

import * as Calendar from 'deposit/constants/calendarValues.js';
import ERRORS from 'deposit/constants/errors.js';

import 'deposit/components/CreditCard/CreditCard.scss';

/* Disable no-unused-prop-types for errors. Errors is ony used to show wich inputs has an error  */
/* eslint react/no-unused-prop-types: 1 */

class CreditCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputs: props.cardInfo,
            formValidation: {
                cardNumber: false,
                cvc: false,
                expiringMonth: false,
                expiringYear: false,
            },
        };

        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.sendResponse = this.sendResponse.bind(this);

        this.calendarYears = [];

        const actualYears = new Date().getFullYear();
        let j;
        for (j = actualYears; j < actualYears + 25; j += 1) {
            this.calendarYears.push({ value: j, label: j });
        }
    }

    componentWillMount() {
        this.sendResponse();

        this.calendarMonths = Calendar.CALENDAR_MONTHS.map(({ value, transKey }) => ({
            value,
            label: LocaleService.t(transKey),
        }));
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.errors.length) {
            const currentState = this.state;
            const error = nextProps.errors.find((mapError) => {
                return mapError.group === 'depositGroup';
            });
            const code = error ? error.code : null;

            if (code === ERRORS.INCORRECT_NUMBER || code === ERRORS.INVALID_NUMBER) {
                currentState.formValidation.cardNumber = false;
            } else if (code === ERRORS.INCORRECT_CVC || code === ERRORS.INVALID_CVC) {
                currentState.formValidation.cvc = false;
            } else if (code === ERRORS.INVALID_EXPIRY_MONTH) {
                currentState.formValidation.expiringMonth = false;
            } else if (code === ERRORS.INVALID_EXPIRY_YEAR) {
                currentState.formValidation.expiringYear = false;
            }

            this.setState(currentState);
        }
    }

    componentWillUpdate(nextProps) {
        return !isEqual(this.props.cardInfo, nextProps.cardInfo);
    }

    handleDropdownChange(option, inputName) {
        const state = this.state;

        state.inputs[inputName] = option.value;
        state.formValidation[inputName] = true;

        this.setState(state, () => {
            this.sendResponse();
        });
    }

    handleInputChange(value, name) {
        const formValidation = this.state.formValidation;
        const inputs = this.state.inputs;
        inputs[name] = value;
        formValidation[name] = ValidationService.validateIsNotEmpty(value);

        if (name === 'cardNumber') {
            formValidation.cardNumber = ValidationService.validateCardNumber(value);
        } else {
            formValidation.cvc = ValidationService.validateCardValidationCode(value);
        }

        this.setState(
            {
                inputs,
                formValidation,
            },
            () => {
                this.sendResponse();
            }
        );
    }

    sendResponse() {
        const areFieldsValid = ValidationService.validateForm(this.state.formValidation);

        const groupResponse = GroupResponseService.createResponse(
            areFieldsValid,
            this.state.inputs,
            'error.group.deposit',
            null,
            'depositGroup'
        );

        this.props.onChange(groupResponse);
    }

    render() {
        return (
            <section className="CreditCard__wrapper">
                <label className="sr-text is-bold">{LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.FORM_TITLE')}</label>
                <InputText
                    label={LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.CARD_NUMBER')}
                    errorLabel={LocaleService.t('COMMONS_FORMS.ERRORS.CARD_NUMBER')}
                    name="cardNumber"
                    type="tel"
                    classNames={['styled-placeholder double-third']}
                    value={this.state.inputs.cardNumber}
                    isValid={this.state.formValidation.cardNumber}
                    isRequired
                    valueChange={this.handleInputChange}
                    hasBeenSubmit={this.props.hasBeenSubmit}
                    minLength={FIELD_LENGTH.CREDIT_CARD_MIN}
                    maxLength={FIELD_LENGTH.CREDIT_CARD_MAX}
                />

                <InputText
                    label={LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.SECURITY_CODE')}
                    errorLabel={LocaleService.t('COMMONS_FORMS.ERRORS.SECURITY_CODE')}
                    name="cvc"
                    type="tel"
                    classNames={['styled-placeholder third']}
                    value={this.state.inputs.cvc}
                    isValid={this.state.formValidation.cvc}
                    isRequired
                    valueChange={this.handleInputChange}
                    hasBeenSubmit={this.props.hasBeenSubmit}
                    minLength={FIELD_LENGTH.SECURITY_CODE_MIN}
                    maxLength={FIELD_LENGTH.SECURITY_CODE_MAX}
                />

                <InputDropDown
                    name="expiringMonth"
                    value={this.state.inputs.expiringMonth}
                    options={this.calendarMonths}
                    placeholder={LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.EXPIRATION_MONTH')}
                    errorLabel={LocaleService.t('COMMONS_FORMS.ERRORS.EXPIRATION_MONTH')}
                    classNames={['input-dropdown third']}
                    hasBeenSubmit={this.props.hasBeenSubmit}
                    isRequired
                    valueChange={this.handleDropdownChange}
                />

                <InputDropDown
                    name="expiringYear"
                    value={this.state.inputs.expiringYear}
                    placeholder={LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.EXPIRATION_YEAR')}
                    errorLabel={LocaleService.t('COMMONS_FORMS.ERRORS.EXPIRATION_YEAR')}
                    options={this.calendarYears}
                    classNames={['input-dropdown third']}
                    hasBeenSubmit={this.props.hasBeenSubmit}
                    isRequired
                    valueChange={this.handleDropdownChange}
                />
            </section>
        );
    }
}
CreditCard.defaultProps = {
    errors: [],
    hasBeenSubmit: false,
};

CreditCard.propTypes = {
    onChange: PropTypes.func.isRequired,
    cardInfo: PropTypes.shape({
        cardNumber: PropTypes.string.isRequired,
        cvc: PropTypes.string.isRequired,
        expiringYear: PropTypes.string.isRequired,
        expiringMonth: PropTypes.string.isRequired,
    }).isRequired,
    errors: PropTypes.arrayOf(
        React.PropTypes.shape({
            code: PropTypes.string.isRequired,
            message: PropTypes.string.isRequired,
        })
    ),
    hasBeenSubmit: PropTypes.bool,
};

CreditCard.displayName = 'CreditCard';

export default CreditCard;



// WEBPACK FOOTER //
// ./src/components/CreditCard/CreditCard.jsx